var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27.5px",
    height: "20px",
    viewBox: "11.25 15 27.5 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#FFFFFF"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/change-priority",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 14.000000)",
    className: "svg-path1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.852531, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 8.88888889 7.40148683e-14 8.88888889 4.4408921e-15 10.5555556 13.3333333 10.5555556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 4.44444444 1.02436578e-13 4.44444444 3.28626015e-14 6.11111111 13.3333333 6.11111111"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 0 7.40148683e-14 0 4.4408921e-15 1.66666667 13.3333333 1.66666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 13.3333333 3.29810253e-13 13.3333333 2.60236277e-13 15 13.3333333 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.3333333 17.7777778 7.40148683e-14 17.7777778 4.4408921e-15 19.4444444 13.3333333 19.4444444"
  })), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    d: "M-2.00797383,6 L-0.765169941,6.50939674 L-2.0105106,11.9991542 C2.67457051,8.88199197 6.62596186,8.55646634 9.60153213,9.31077026 C12.754711,10.103476 14.7854676,12.0482373 15.5973598,12.9505537 C15.8522589,13.2348799 15.9867763,13.4182424 16,13.4350273 L14.9731079,14.368116 C14.9731079,14.368116 14.9717399,14.3668444 14.9603402,14.3515854 C14.9254568,14.3058084 14.8242268,14.1776327 14.66007,13.9947788 C13.9619475,13.2135173 12.1211113,11.4544074 9.31083777,10.7517298 C6.65195335,10.0899972 3.10092224,10.3204083 -1.35798726,13.286252 L3.28703582,14.617279 L2.81964489,16 L-4,13.7526691 L-2.00797383,6 Z",
    id: "Path",
    transform: "translate(6.000000, 11.000000) scale(-1, 1) rotate(85.000000) translate(-6.000000, -11.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePriority);
export default __webpack_public_path__ + "static/media/change-priority.ae4cfbf81514e64820ff6abd550227c2.svg";
export { ForwardRef as ReactComponent };